import { render, staticRenderFns } from "./SalReceivableList.vue?vue&type=template&id=600891a2&scoped=true&"
import script from "./SalReceivableList.vue?vue&type=script&lang=js&"
export * from "./SalReceivableList.vue?vue&type=script&lang=js&"
import style0 from "./SalReceivableList.vue?vue&type=style&index=0&id=600891a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600891a2",
  null
  
)

export default component.exports